interface SectionProps {

}

export abstract class Section {
    abstract id: string;
    abstract name: string;
    abstract isVisible: boolean;
    abstract element: (props?: SectionProps) => JSX.Element;
}